<div class="validation-modal-header">
  <div class="header-info">

    <h4>Vehículos a Asociar <span class="text-danger">*</span></h4>
  </div>
</div>
<p class="mb-2" style="color: var(--gl-text-secondary);">
  Aquí se mostrarán las unidades seleccionadas. Debe seleccionar al menos una unidad para continuar.
</p>
<!-- Filtro para Vehículos Seleccionados -->
<div class="mb-2">
  <label class="text-form-label mb-1">Buscar Placa o Código</label>
  <div class="search-container-clean shadow-sm d-flex flex-row">
    <i class="material-icons search-icon-clean">search</i>
    <input class="text-input-clean" type="text" [(ngModel)]="selectedVehiclesSearchQuery"
      placeholder="Buscar entre los seleccionados...">
    <button *ngIf="selectedVehiclesSearchQuery" class="btn btn-outline-secondary border-0 py-0 px-2 ms-2" type="button"
      (click)="selectedVehiclesSearchQuery = ''">
      <i class="material-icons align-middle" style="font-size: 14px;">clear</i>
    </button>
  </div>
</div>

<!-- Contador / Info de Coincidencias en Seleccionados -->
<div class="d-flex justify-content-between align-items-center mb-2 px-1 text-muted"
  style="font-size: 0.73rem; font-weight: 600;">
  <span>Total a asociar: {{ vehicleSelected.length }}</span>
  <span *ngIf="selectedVehiclesSearchQuery">Filtrados: {{ getSelectedVehiclesFiltered().length }}</span>
</div>

<!-- Listado de Seleccionados (Cuadrilla/Grid igual al izquierdo) -->
<div class="vehicle-scroll-container">
  <ng-container *ngIf="getSelectedVehiclesFiltered().length > 0; else emptySelected">
    <div class="vehicles-grid">
      <div class="vehicle-pill selected" *ngFor="let v of getSelectedVehiclesFiltered()" (click)="removeVehicle(v)"
        style="background: #f0fdf4; border-color: #bbf7d0; color: #166534;">
        <span class="pill-text" [title]="v.unitCode + ' (' + v.plate + ')'">
          {{ v.unitCode }} ({{ v.plate }})
        </span>
        <i class="material-icons text-danger" style="font-size: 14px;">cancel</i>
      </div>
    </div>
  </ng-container>

  <ng-template #emptySelected>
    <div class="empty-state-list h-100 justify-content-center">
      <i class="material-icons">no_crash</i>
      <p>{{ vehicleSelected.length > 0 ? 'Sin resultados para la búsqueda' : 'Ningún vehículo seleccionado' }}
      </p>
      <span class="text-muted mt-1">
        {{ vehicleSelected.length > 0 ? 'Prueba con otros términos de búsqueda.' : 'Haz clic en unidades de la
        izquierda para agregarlas.' }}
      </span>
    </div>
  </ng-template>
</div>

<!-- Indicador de estado -->
<div class="mt-3 pt-2 border-top" *ngIf="vehicleSelected.length > 0">
  <div class="p-2 bg-white border rounded-3 text-muted" style="font-size: 0.72rem; line-height: 1.4;">
    <i class="material-icons text-warning align-middle me-1" style="font-size: 14px;">info</i>
    Las unidades se registrarán con estado <strong>Pendiente</strong>.
  </div>
</div>